import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ChatbotOptionAttributes } from '../types/interfaces/chat-option';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class OptionsMaintenanceService {
  constructor(private http: HttpClient) {}

  getOptions(): Observable<ChatbotOptionAttributes[]> {
    return this.http.get<ChatbotOptionAttributes[]>(
      `${environment.apiHost}/maintenance/options`,
      {
        withCredentials: true,
      }
    );
  }

  createOption(option: ChatbotOptionAttributes): Observable<ChatbotOptionAttributes> {
    return this.http.post<ChatbotOptionAttributes>(
      `${environment.apiHost}/maintenance/options`,
      option,
      {
        withCredentials: true,
      }
    );
  }

  updateOption(option: ChatbotOptionAttributes): Observable<ChatbotOptionAttributes> {
    return this.http.put<ChatbotOptionAttributes>(
      `${environment.apiHost}/maintenance/options/${option.id}`,
      option,
      {
        withCredentials: true,
      }
    );
  }

  deleteOption(optionId: number): Observable<ChatbotOptionAttributes> {
    return this.http.delete<ChatbotOptionAttributes>(
      `${environment.apiHost}/maintenance/options/${optionId}`,
      {
        withCredentials: true,
      }
    );
  }
}
